// extracted by mini-css-extract-plugin
export default {"blacklist_list_title":"blacklist_blacklist_list_title__6pGDH","blacklist_title-text":"blacklist_blacklist_title-text__CfqR1"};